import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Form, Input } from "antd";
import { doCreateCategory } from "stores/slices/category";

import AppButton from "components/button";
const CategoryForm = props => {
  const {
    setIsOpenCategoryForm,
    listAllCategory,
    setListAllCategory,
    formTemplateRef,
    workspaceId,
    isSuperAdmin,
  } = props;
  const formRef = React.useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const validateMessages = {
    required: t("validate.required"),
  };

  const onFinish = async fieldsValue => {
    const params = {
      category: fieldsValue["category"].trim(),
    };
    if (isSuperAdmin) {
      params.workspaceId = workspaceId;
    }
    const { payload } = await dispatch(doCreateCategory(params));
    if (payload && payload.status === 200) {
      const newCategory = {
        value: payload.data.id,
        label: payload.data.category,
      };
      setListAllCategory([...listAllCategory, newCategory]);
      formTemplateRef.current.setFieldsValue({
        category: newCategory.value,
      });
      setIsOpenCategoryForm(false);
    }
  };

  return (
    <Form
      name="basic"
      onFinish={onFinish}
      ref={formRef}
      layout={"vertical"}
      validateMessages={validateMessages}
      initialValues={{
        fieldName: "",
      }}
      style={{
        marginBottom: "0px",
      }}
    >
      <Form.Item
        label="Category"
        name="category"
        rules={[
          {
            required: true,
            message: "Please input your category",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item>
        <div
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "end",
            gap: "16px",
          }}
        >
          <AppButton
            label={t("button.cancel")}
            color={"grey"}
            size={"medium"}
            htmlType="button"
            // loading={loading}
            onClick={() => {
              setIsOpenCategoryForm(false);
            }}
          />

          <AppButton
            label={t("button.save")}
            color={"blue"}
            size={"medium"}
            type="primary"
            htmlType="submit"
          />
        </div>
      </Form.Item>
    </Form>
  );
};
export default CategoryForm;
